import { ServerType } from '../server.interface';
import { isMtServerType } from './isMtServerType';

// Independent markout: MT4/MT5 through the plugin (LB-4701), cTrader through the cTrader Manager connection (LB-4732);
// Taker FIX API has neither
export const isRiskReportingSupported = (type?: ServerType): boolean => isMtServerType(type) || type === ServerType.cTrader;

// The cTrader Manager settings are shown, validated and sent only for a cTrader server with risk reporting on
export const usesCTraderManagerSettings = (type?: ServerType, riskReportingEnabled?: boolean): boolean =>
  type === ServerType.cTrader && Boolean(riskReportingEnabled);
